import React from "react";
import { X, ExternalLink, FileText, Play } from "react-feather";

function ResourceViewerModal({ show, onClose, title, url, type }) {
    if (!show || !url) return null;

    // Helper to format embed URLs for YouTube or drive links
    const getEmbedUrl = (rawUrl) => {
        if (!rawUrl) return "";
        let src = rawUrl.trim();

        // Convert YouTube links (watch?v= or youtu.be/) into embed links
        if (src.includes("youtube.com/watch") || src.includes("youtu.be/")) {
            const videoId = src.includes("youtu.be/")
                ? src.split("youtu.be/")[1]?.split("?")[0]
                : new URLSearchParams(src.split("?")[1]).get("v");
            if (videoId) {
                return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
            }
        }

        // Convert Google Drive view links to preview links for iframe embed
        if (src.includes("drive.google.com/file/d/")) {
            return src.replace(/\/view.*$/, "/preview");
        }

        return src;
    };

    const isVideo = type === "video" || url.match(/\.(mp4|webm|mov|mkv)$/i) || url.includes("youtube.com") || url.includes("youtu.be");
    const embedUrl = getEmbedUrl(url);

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(15, 23, 42, 0.75)",
                backdropFilter: "blur(6px)",
                zIndex: 99999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "1rem"
            }}
            onClick={onClose}
        >
            <div
                style={{
                    width: "92vw",
                    maxWidth: "1050px",
                    height: "88vh",
                    backgroundColor: "#ffffff",
                    borderRadius: "1rem",
                    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden"
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "1rem 1.5rem",
                        borderBottom: "1px solid #e2e8f0",
                        background: "#f8fafc"
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
                        {isVideo ? (
                            <Play size={20} color="#e11d48" />
                        ) : (
                            <FileText size={20} color="#059669" />
                        )}
                        <h4 style={{ margin: 0, fontSize: "1.05rem", fontWeight: 700, color: "#0f172a" }}>
                            {title || (isVideo ? "Video Guide Viewer" : "PDF Guide / Document Viewer")}
                        </h4>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                        <a
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
                            style={{ fontSize: "0.8rem", fontWeight: "600", borderRadius: "0.5rem" }}
                            title="Open in new browser tab"
                        >
                            Open External <ExternalLink size={13} />
                        </a>
                        <button
                            onClick={onClose}
                            style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "0.35rem",
                                borderRadius: "0.5rem",
                                color: "#64748b",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                            type="button"
                            aria-label="Close viewer"
                        >
                            <X size={20} />
                        </button>
                    </div>
                </div>

                {/* Body Viewer */}
                <div style={{ flex: 1, backgroundColor: "#0f172a", position: "relative" }}>
                    {isVideo && (url.endsWith(".mp4") || url.endsWith(".webm") || url.endsWith(".mov")) ? (
                        <video
                            controls
                            autoPlay
                            src={url}
                            style={{ width: "100%", height: "100%", objectFit: "contain" }}
                        />
                    ) : (
                        <iframe
                            src={embedUrl}
                            title={title || "Resource Viewer"}
                            style={{ width: "100%", height: "100%", border: "none" }}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default ResourceViewerModal;
